import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { AdverseMediaListRequest } from '~bank-adverse-media/types'

import { useAdverseMediaListContext } from '../../context/AdverseMediaListContext'

import * as SC from './styles'

export const Filter = () => {
  const { data, isChanged, state, navigate, clear } = useAdverseMediaListContext()

  const formApi = useForm({
    defaultValues: {
      riskLevel: state.riskLevel || '',
      entityType: state.entityType || ''
    } as Pick<AdverseMediaListRequest, 'riskLevel' | 'entityType'>
  })

  const clearForm = () => {
    formApi.reset()
    clear()
  }

  const updateSearchParams = (newValue: Partial<Pick<AdverseMediaListRequest, 'riskLevel' | 'entityType'>>) =>
    navigate({ page: 1, ...newValue })

  return (
    <FilterPanel isDirty={isChanged} onReset={clearForm}>
      <SC.Box>
        <SC.Wrapper>
          <formApi.Field
            name="riskLevel"
            listeners={{
              onChange: ({ value }) => {
                updateSearchParams({ riskLevel: value })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                field={field}
                label="Risk Level"
                input={(inputProps) => <Select data={data?.riskLevels || []} {...inputProps} />}
              />
            )}
          />
        </SC.Wrapper>
        <SC.Wrapper>
          <formApi.Field
            name="entityType"
            listeners={{
              onChange: ({ value }) => {
                updateSearchParams({ entityType: value })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                field={field}
                label="Entity Type"
                input={(inputProps) => <Select data={data?.entityTypes || []} {...inputProps} />}
              />
            )}
          />
        </SC.Wrapper>
      </SC.Box>
    </FilterPanel>
  )
}
